/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Product_Default_Shelf_Life1Inputs */

const vi_sitesettings_product_default_shelf_life1 = /** @type {(inputs: Sitesettings_Product_Default_Shelf_Life1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạn sử dụng mặc định`)
};

/**

* @param {Sitesettings_Product_Default_Shelf_Life1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_product_default_shelf_life1 = /** @type {((inputs?: Sitesettings_Product_Default_Shelf_Life1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Product_Default_Shelf_Life1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_product_default_shelf_life1(inputs)
});
export { sitesettings_product_default_shelf_life1 as "siteSettings_product_default_shelf_life" }